// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"252":"f77a2c0f","289":"14790efd","465":"58fefa0f","644":"e7da2743","783":"a10dea96","888":"83485e0e"}[chunkId] + ".css";
};